import React, { createContext, useMemo } from 'react'

import type { IProps, IUserNavContext } from './interfaces'

export const UserNavContext = createContext<IUserNavContext | null>(null)

export const UserNavProvider = ({
  userId,
  userName,
  companyId,
  companyName,
  isAdminView,
  children,
}: IProps): React.JSX.Element => {
  const contextValue = useMemo(
    (): IUserNavContext => ({ userId, userName, companyId, companyName, isAdminView }),
    [userId, userName, companyId, companyName, isAdminView],
  )

  return <UserNavContext value={contextValue}>{children}</UserNavContext>
}
